import { FormOptionDto } from "src/models"
import { cn } from "src/lib/utils"

export type NumberFormat = ["text", "currency"]

export interface CustomNumberInputProps {    
  value?: any
  name: string
  label?: string
  id?: string
  placeholder?: string
  onChange: (value: {value : number | null, display: string}) => void
  required? : boolean | false
  errorMessage? : string,
  customClassName?: string | null,
  decimals? : number | 0,
  maxlength? : number
  }

const CustomNumberInput = ({ value, name, label,  id, placeholder, required, errorMessage, customClassName, decimals, maxlength, onChange}: CustomNumberInputProps) => {
    const hasError = !!errorMessage;

    const formatNumber = (val: string) => {
      if (!val) return "";

      // Remove non-numeric characters except decimal
      if (val.charAt(0) == "0")
      {
        val = val.slice(0, 0) + val.slice(1);
      }
      let num = val.replace(/[^\d.]/g, "");

      if (decimals && decimals > 0) {
        const parts = num.split(".");
        // Allow only one decimal
        if (parts.length > 2) {
          num = parts[0] + "." + parts[1];
        }
        // Limit decimal places
        if (parts[1]) {
          parts[1] = parts[1].slice(0, decimals);
          num = parts[0] + "." + parts[1];
        }
      } else {
        num = num.replace(/\./g, "");
      }

      // Add thousand separators
      const [intPart, decPart] = num.split(".");
      const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return decPart !== undefined ? `${formattedInt}.${decPart}` : formattedInt;
    };
    
    const handleInputChange = (e : React.ChangeEvent<HTMLInputElement>) => {
      const raw = e.target.value;
        const cleaned = raw.replace(/[^0-9.]/g, "");

      const formatted = formatNumber(cleaned);
      const parsed = cleaned === "" ? null : parseFloat(cleaned);

      
      onChange({
        display : formatted,
        value : parsed
      });
    }

      const displayValue =
    value !== null && value !== undefined
      ? formatNumber(value.toString())
      : "";

    return (
    <>
      {label && label.trim().length > 0 && (
        <label
          htmlFor={id || name}
          className="block text-sm font-semibold leading-6 text-gray-900"
        >
          {label}{required && <span className="text-red-500 font-bolder ml-1">*</span>}

        </label> 
      )}

      <input type="text"
        name={name}
        id={id || name}
        value={displayValue}
        onChange={(e) => handleInputChange(e)}
        placeholder={placeholder ?? "0.00"}
        className={cn( 
            (customClassName && customClassName.trim().length > 0) ? customClassName :
            `text-sm mt-2 text-right block w-full rounded-md border-0 py-1.5 px-5 text-gray-900  ring-inset focus:ring-2 sm:text-sm sm:leading-6`, 
            !hasError ? ` ring-1 ring-gray-300  focus:ring-indigo-600 ` : `ring-2 ring-red-300 focus:ring-red-600 `)
        }
        // className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
      ></input>

      {hasError && (
        <span className="text-red-600 text-sm">{errorMessage}</span>
      )}
     
    </>
  )
}

export default CustomNumberInput;